import { first } from 'rxjs/operators';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';

@Component({
    selector: 'create-site',
    template: `
        <mat-toolbar>
            <button mat-icon-button (click)="back()" matTooltip="Back to Site List">
                <mat-icon aria-label="Back to List">keyboard_backspace</mat-icon>
            </button>
        </mat-toolbar>
        <div fxLayout="column">
            <tenant-editor *ngIf="newTenant" [tenant]="newTenant" (tenantSaved)="done()" (cancelled)="done()"></tenant-editor>
        </div>
    `
})
export class CreateSiteComponent {
    noTouching: boolean;
    newTenant: any;

    constructor(private router: Router, 
                private route: ActivatedRoute,
                private tenantService: TenantService) {}

    back() {
        this.router.navigate(['settings', 'partner', 'sites', 'list'], { queryParams: this.route.snapshot.queryParams});
    }

    done = tenant => this.router.navigate(['settings', 'partner', 'sites', 'list'], { queryParams: this.route.snapshot.queryParams});

    ngOnInit() {
        this.tenantService.getUnauthTenantInfo().pipe(first())
        .subscribe(tenant => this.newTenant = this.tenantService.starterTenant(tenant.id, 
                                                                               tenant.settings.title, 
                                                                               tenant.settings.hideHelp, 
                                                                               tenant.settings.allowedSources, 
                                                                               tenant.settings.limitProductSources));
    }
}
